<template>
  <transition name="fade">
    <div class="level3-modal-container">
      <div class="lv3-title-text">KINERJA KPLH</div>
      <div class="lv3-edit-form">
        <div class="edit-form-wrapper">
          <div>Nilai</div>
          <input class="lv3-input-text" type="number" v-model="nilai" />
        </div>
        <div class="edit-form-wrapper">
          <div>Tingkat Risiko</div>
          <select style="width: 100%;" v-model="tingkat_resiko">
            <option :value="''">Pilih Tingkat Risiko</option>
            <option v-for="(list, index) in tingkat_resiko_ops" :value="list" :key="index">
              {{ list }}
            </option>
          </select>
        </div>
        <div class="edit-form-wrapper">
          <div>Keterangan</div>
          <!-- <input class="lv3-input-text" type="text" v-model="keterangan" /> -->
          <select style="width: 100%;" v-model="keterangan">
            <option :value="''">Pilih Keterangan</option>
            <option v-for="(list, index) in keterangan_ops" :value="list" :key="index">
              {{ list }}
            </option>
          </select>
        </div>
        <div class="form-date-wrapper">
          <div class="edit-form-wrapper">
            <div>Tanggal Efektif</div>
            <input class="lv3-input-date" type="date" v-model="tanggal_efektif" />
          </div>
          <div class="edit-form-wrapper">
            <div>Tanggal Berakhir</div>
            <input class="lv3-input-date" type="date" v-model="tanggal_berakhir" />
          </div>
        </div>
        <div class="edit-form-wrapper">
          <div>PIC</div>
          <input class="lv3-input-text" type="text" v-model="pic" />
        </div>
        <div class="edit-form-wrapper">
          <div>Last Reviewer Name</div>
          <input class="lv3-input-text" type="text" v-model="last_reviewer" />
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Attachment</div>
          <!-- <input type="file" class="hiw-text"> -->
          <label class="btn btn-default btn-file">
            <i class="fas fa-upload"></i>
            {{ theFileName }}
            <input type="file" style="display: none;" @change="fileChangeHandler" />
          </label>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitDoc($store.state.editStore.kplhDetail.id)">
            CONFIRM
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      tingkat_resiko_ops: ['KRITIS', 'TINGGI', 'SEDANG', 'RENDAH'],
      keterangan_ops: ['TIDAK LULUS PRAQUALIFIKASI', 'LULUS PRAQUALIFIKASI', 'LULUS DENGAN CATATAN'],
      email: null,
      customText: null,
      tempText: null,
      files: [],
      labelPlaceholder: 'Upload Dokumen',
    }
  },
  computed: {
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      } else if (this.$store.state.editStore.kplhDetail.attachment) {
        return this.$store.state.editStore.kplhDetail.attachment
      } else {
        return this.labelPlaceholder
      }
    },
    tanggal_efektif: {
      get() {
        return this.formatDateInput(
          this.$store.state.editStore.kplhDetail.tanggal_efektif
        )
      },
      set(newValue) {
        this.$store.commit('editStore/SET_OBJECT', {
          state: 'kplhDetail',
          key: 'tanggal_efektif',
          value: this.formatDateInput(newValue),
        })
      },
    },
    tanggal_berakhir: {
      get() {
        return this.formatDateInput(
          this.$store.state.editStore.kplhDetail.tanggal_berakhir
        )
      },
      set(newValue) {
        this.$store.commit('editStore/SET_OBJECT', {
          state: 'kplhDetail',
          key: 'tanggal_berakhir',
          value: this.formatDateInput(newValue),
        })
      },
    },
    nilai: {
      get() {
        return this.$get(this.$store, 'state.editStore.kplhDetail.nilai')
      },
      set(newValue) {
        this.$store.commit('editStore/SET_OBJECT', {
          state: 'kplhDetail',
          key: 'nilai',
          value: newValue,
        })
      },
    },
    keterangan: {
      get() {
        return this.$store.state.editStore.kplhDetail.keterangan
      },
      set(newValue) {
        this.$store.commit('editStore/SET_OBJECT', {
          state: 'kplhDetail',
          key: 'keterangan',
          value: newValue,
        })
      },
    },
    tingkat_resiko: {
      get() {
        return this.$store.state.editStore.kplhDetail.tingkat_resiko
      },
      set(newValue) {
        this.$store.commit('editStore/SET_OBJECT', {
          state: 'kplhDetail',
          key: 'tingkat_resiko',
          value: newValue,
        })
      },
    },
    pic: {
      get() {
        return this.$store.state.editStore.kplhDetail.pic
      },
      set(newValue) {
        this.$store.commit('editStore/SET_OBJECT', {
          state: 'kplhDetail',
          key: 'pic',
          value: newValue,
        })
      },
    },
    last_reviewer: {
      get() {
        if (
          !this.$get(this.$store, 'state.editStore.kplhDetail.last_reviewer')
        ) {
          this.$store.commit('editStore/SET_OBJECT', {
            state: 'kplhDetail',
            key: 'last_reviewer',
            value: this.$store.state.currentUser,
          })
        }
        return this.$store.state.editStore.kplhDetail.last_reviewer
      },
      set(newValue) {
        this.$store.commit('editStore/SET_OBJECT', {
          state: 'kplhDetail',
          key: 'last_reviewer',
          value: newValue,
        })
      },
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.nilai, 'Nilai'],
        [this.keterangan, 'Keterangan'],
        [this.tingkat_resiko, 'Tingkat Resiko'],
        [this.pic, 'PIC'],
        [this.last_reviewer, 'Last Reviewer'],
      ]

      return this.multiConditions(arr)
    },
    submitDoc(id) {
      if (this.checkForm()) {
        let request = {
          id,
          update_by: this.$store.state.currentUser,
          vendor_id: this.$store.state.level1.vendorId,
          nilai: this.nilai,
          keterangan: this.keterangan,
          tingkat_resiko: this.tingkat_resiko,
          pic: this.pic,
          last_reviewer: this.last_reviewer,
        }

        if (this.tanggal_efektif) {
          request['tanggal_efektif'] = this.tanggal_efektif
        }

        if (this.tanggal_berakhir) {
          request['tanggal_berakhir'] = this.tanggal_berakhir
        }

        if (this.files && this.files.length > 0) {
          request['attachment'] = this.files[0]
        }

        this.$store.dispatch('editStore/updateKplh', request)
      }
    },
    closeModal() {
      const self = this
      self.$store.commit('modalStore/CLOSE_KPLH')
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
